import { Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LinkifyPipe } from '../../../bericht/pipes/linkify.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { checkIfActiveDate } from '../../../utils';
import { AfwezigheidDto } from 'parkour-web-app-dto';
import { ProfielDetailsCardComponent } from '../profiel-details-card/profiel-details-card.component';

@Component({
  selector: 'parkour-profiel-details-afwezigheid-card',
  standalone: true,
  imports: [DatePipe, LinkifyPipe, TranslateModule, ProfielDetailsCardComponent],
  templateUrl: './profiel-details-afwezigheid-card.component.html',
})
export class ProfielDetailsAfwezigheidCardComponent {
  public readonly afwezigheid = input.required<AfwezigheidDto>();
  public readonly alwaysShow = input<boolean>();
  protected readonly checkIfActiveDate = checkIfActiveDate;
}
